export default function preloaderGame9 (scene) {

    // scene.load.image(`background-game9`, `/img/game9/background.png`);
    // scene.load.image(`background-mobile-game9`, `/img/game9/background-mobile.png`);
    // scene.load.image(`road-game9`, `/img/game9/road.png`);
    // scene.load.image(`road-mobile-game9`, `/img/game9/road-mobile.png`);
    scene.load.image(`fulltrip-mobile-game9`, `/img/game9/Boca_Edit 2.png`);
    // scene.load.image(`fulltrip-mobile-game9`, `/img/game9/background-mobile-final.png`);
    scene.load.image(`bullet-right-game9`, `/img/game9/enemies/bullet.png`);

	scene.load.audio("bocaSong", ["/audio/songs/9-boca.mp3"]);
	
	scene.load.spritesheet(`jiu-game9`, 
		`/img/game9/jiu.png`,
		{ frameWidth: 25, frameHeight: 37}
	);
	
	scene.load.spritesheet(`jiu2-game9`, 
		`/img/game9/jiu-2.png`,
		{ frameWidth: 27, frameHeight: 37}
	);
	
	scene.load.spritesheet(`jiu3-game9`, 
		`/img/game9/jiu-3.png`,
		{ frameWidth: 27, frameHeight: 37}
	);

	scene.load.spritesheet(`sua-game9`, 
		`/img/game9/sua.png`,
		{ frameWidth: 25, frameHeight: 37}
	);
	
	scene.load.spritesheet(`sua2-game9`, 
		`/img/game9/sua-2.png`,
		{ frameWidth: 27, frameHeight: 37}
	);
	
	scene.load.spritesheet(`sua3-game9`, 
		`/img/game9/sua-3.png`,
		{ frameWidth: 27, frameHeight: 37}
	);

	scene.load.spritesheet(`siyeon-game9`, 
		`/img/game9/siyeon.png`,
		{ frameWidth: 25, frameHeight: 37}
	);
	
	scene.load.spritesheet(`siyeon2-game9`, 
		`/img/game9/siyeon-2.png`,
		{ frameWidth: 25, frameHeight: 37}
	);
	
	scene.load.spritesheet(`siyeon3-game9`, 
		`/img/game9/siyeon-3.png`,
		{ frameWidth: 25, frameHeight: 37}
	);
	
	scene.load.spritesheet(`handong-game9`, 
		`/img/game9/handong.png`,
		{ frameWidth: 25, frameHeight: 37}
	);
	
	scene.load.spritesheet(`handong2-game9`, 
		`/img/game9/handong-2.png`,
		{ frameWidth: 25, frameHeight: 37}
	);
	
	scene.load.spritesheet(`handong3-game9`, 
		`/img/game9/handong-3.png`,
		{ frameWidth: 25, frameHeight: 37}
	);
	
	scene.load.spritesheet(`yoohyeon-game9`, 
		`/img/game9/yoohyeon.png`,
		{ frameWidth: 25, frameHeight: 37}
	);
	
	scene.load.spritesheet(`yoohyeon2-game9`, 
		`/img/game9/yoohyeon-2.png`,
		{ frameWidth: 25, frameHeight: 37}
	);
	
	scene.load.spritesheet(`yoohyeon3-game9`, 
		`/img/game9/yoohyeon-3.png`,
		{ frameWidth: 25, frameHeight: 37}
	);

	scene.load.spritesheet(`dami-game9`, 
		`/img/game9/dami.png`,
		{ frameWidth: 25, frameHeight: 37}
	);
	
	scene.load.spritesheet(`dami2-game9`, 
		`/img/game9/dami-2.png`,
		{ frameWidth: 25, frameHeight: 37}
	);
	
	scene.load.spritesheet(`dami3-game9`, 
		`/img/game9/dami-3.png`,
		{ frameWidth: 25, frameHeight: 37}
	);
	
	scene.load.spritesheet(`gahyeon-game9`,
		`/img/game9/gahyeon.png`,
		{ frameWidth: 25, frameHeight: 37}
	);
	
	scene.load.spritesheet(`gahyeon2-game9`,
		`/img/game9/gahyeon-2.png`,
		{ frameWidth: 25, frameHeight: 37}
	);
	
	scene.load.spritesheet(`gahyeon3-game9`,
		`/img/game9/gahyeon-3.png`,
		{ frameWidth: 25, frameHeight: 37}
	);

	scene.load.spritesheet(`humo-game9`, 
		`/img/generalSprites/humo-infinite.png`,
		{ frameWidth: 41, frameHeight: 42}
	);

	scene.load.spritesheet(`jiu-e-game9`, 
		`/img/game9/enemies/jiu.png`,
		{ frameWidth: 25, frameHeight: 37}
	);
	
	scene.load.spritesheet(`sua-e-game9`, 
		`/img/game9/enemies/sua.png`,
		{ frameWidth: 25, frameHeight: 37}
	);
	
	scene.load.spritesheet(`siyeon-e-game9`, 
		`/img/game9/enemies/siyeon.png`,
		{ frameWidth: 25, frameHeight: 37}
	);
	
	scene.load.spritesheet(`handong-e-game9`, 
		`/img/game9/enemies/handong.png`,
		{ frameWidth: 25, frameHeight: 37}
	);
	
	scene.load.spritesheet(`yoohyeon-e-game9`, 
		`/img/game9/enemies/yoohyeon.png`,
		{ frameWidth: 25, frameHeight: 37}
	);
	
	scene.load.spritesheet(`dami-e-game9`, 
		`/img/game9/enemies/dami.png`,
		{ frameWidth: 25, frameHeight: 37}
	);
	
	scene.load.spritesheet(`gahyeon-e-game9`, 
		`/img/game9/enemies/gahyeon.png`,
		{ frameWidth: 25, frameHeight: 37}
	);

	// scene.load.spritesheet(`bullet-right-game9`,
	// 	`/img/game9/enemies/bullet.png`,
	// 	{ frameWidth: 30, frameHeight: 20}
	// );


}